import makeAsyncScriptLoader from 'react-async-script'

export default function injectGoogleMaps(component) {
  const element = document.querySelector('meta[name="google-api-key"]')
  const apiKey = element.getAttribute('content')
  const url = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`

  return makeAsyncScriptLoader(url, { globalName: 'google' })(component)
}
